import { render } from "./SquadComponent.vue?vue&type=template&id=e2770db2&scoped=true"
import script from "./SquadComponent.vue?vue&type=script&lang=js"
export * from "./SquadComponent.vue?vue&type=script&lang=js"

import "./SquadComponent.vue?vue&type=style&index=0&id=e2770db2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2770db2"]])

export default __exports__